const wasmCheck = require("wasm-check");
import createTFLiteModule from "../vendor/tflite/tflite";
import createTFLiteSIMDModule from "../vendor/tflite/tflite-simd";
import StreamBackgroundEffect from "./StreamBackgroundEffect";
import { enxLog } from '../helpers.js';
import uuid from "uuid";
import "../style.scss";

// "use strict"
export default class EnxVb {
  constructor(config) {

    // console.log('config: ', config);
    this.config = config;
    this.vbList = config.listContainer;
    this.previewDomElement = config.previewDomElement;
    this.domElement = config.domElement;
    this.defaultBg = config.defaultBg;
    this.selectedImageData = null;
    this.streamMainBGEffect = null;
    this.streamPreviewBGEffect = null;
    this.setBackground = null;
    this.previewInputCanvas = "vb-preview-input-canvas-element";
    this.previewInputVideo = "vb-preview-input-video-element";
    this.mainOutputCanvas = "vb-main-output-canvas-element";
    this.mainOutputVideo = "vb-main-output-video-element";
    this.handleApplyEffect = this.config.handleApplyEffect ? this.config.handleApplyEffect : () => { };
    this.models = {
      model96: "/libs/segm_lite_v681.tflite",
      model144: "/libs/segm_full_v679.tflite",
      modelLandscape: '/libs/selfie_segmentation_landscape.tflite'
    };
    this.segmentationDimensions = {
      model96: {
        height: 96,
        width: 160,
      },
      model144: {
        height: 144,
        width: 256,
      },
      modelLandscape: {
        height: 144,
        width: 256
      }
    };
    this.images = [
      {
        id: "-1",
        src: "none",
        category: "predefined",
      },
      {
        id: "0",
        src: "blur",
        category: "predefined",
      }
    ];

    this.closeIcon = `<svg  viewBox="0 0 64 64" xml:space="preserve" style="position:absolute;height:25px;width:25px;">
        <style type="text/css">.cst0{fill:#134563;}</style><g><g id="Icon-Minus" transform="translate(78.000000, 278.000000)" class="cst0"><path class="cst0" d="M-45.9-222.1c-13.2,0-23.9-10.7-23.9-23.9c0-13.2,10.7-23.9,23.9-23.9S-22-259.3-22-246.1     C-22-232.9-32.7-222.1-45.9-222.1L-45.9-222.1z M-45.9-267.4c-11.7,0-21.3,9.6-21.3,21.3c0,11.7,9.6,21.3,21.3,21.3     s21.3-9.6,21.3-21.3C-24.6-257.8-34.2-267.4-45.9-267.4L-45.9-267.4z" id="Fill-41"/><polygon class="cst0" id="Fill-42" points="-58.7,-247.5 -33.2,-247.5 -33.2,-244.7 -58.7,-244.7    "/></g></g></svg>`;

    // Set external images
    this.setExternalImages(this.config.imagesFromQS, this.config.imagesFromDB);

    this.init();
  }

  init() {
    let _this = this;
    console.log('_this.images: ', _this.images);
    _this.images.forEach((image, index) => {

      let img = null;
      if (image.src !== "blur" && image.src !== "none") {
        img = document.createElement("img");
        img.src = image.src;
        img.id = image.id;
        img.classList.add("img-fluid");
        img.style.width = `8rem`;
        if (this.config?.stream?.config?.video === false) {
          toastr.error('Camera not found');
        }
        // else {
          img.onclick = (e) => {
            _this.setImageBackground("vb", image, true);
          };
        // }
        // console.log('THIS IMAGE IS SELECTED 1', image.src , " ", this.defaultBg);
        if (this.defaultBg != null && this.defaultBg == image.src) {
          // console.log('THIS IMAGE IS SELECTED 2', image.src , " ", this.defaultBg);

          _this.setImageBackground("vb", image, true);
        }
      } else {
        img = document.createElement("div");
        img.id = image.id;
        img.classList.add(`add-${image.src}`);
        img.innerText = image.src.toUpperCase();
        if (this.config?.stream?.config?.video === false) {
          toastr.error('Camera not found');
        }
        // else {
          img.onclick = (e) => {
            _this.setImageBackground(image.src, image, true);
          };
        // }
      }

      if (!document.querySelector(`#img-${image.id}`)) {
        let cont = document.createElement("div");
        cont.id = `img-${image.id}`;
        cont.classList.add("vb-image");

        // if (image.category === "uploaded") {
        //   let removeIcon = document.createElement("div");
        //   removeIcon.classList.add("remove-uploaded-image");
        //   removeIcon.id = `rui-${image.id}`;
        //   removeIcon.innerHTML = "X";
        //   removeIcon.onclick = () => {
        //     _this.deleteUploadedImage(image);
        //   };
        //   cont.append(removeIcon);
        // }

        if (img) {
          cont.append(img);
        }
        _this.vbList.append(cont);
      }
    });
  }

  /**
   * Check if video is enabled in stream
   */
  checkIfVideoEnabled(type, img, image) {
    if (this.config?.stream?.config?.video === false) {
      toastr.error('Camera not found');
    }
    else {
      img.onclick = (e) => {
        this.setImageBackground(type, image, true);
      };
    }
  }

  isEffectSelected(element) {
    return element.classList.contains('vb-selected');
  }



  clearSelectedItem() {
    document.querySelectorAll(".vb-image").forEach(item => item.classList.remove('vb-selected'));
  }

  deleteUploadedImage(image) {
    this.images = this.images.filter((item) => item.id != image.id);
    if (document.querySelector(`#img-${image.id}`)) {
      document.querySelector(`#img-${image.id}`).remove();
    }
  }

  /**
   * Set Image background
   * @param {*} vbType 
   * @param {*} image 
   * @param {*} newImage 
   * @param {*} reapply 
   * @returns 
   */
  async setImageBackground(vbType, image = null, newImage = false, reapply = false) {
    if (this.config?.stream?.config?.video === false || !this.config.stream) {
      return;
    }
    if (reapply) {
      enxLog('Re applying...');
    }
    console.log('vbType, image, newImage: ', vbType, image, newImage);
    console.log('%c%s', 'color: #FFFFFF; background: red; font-size: 16px;', `Initiating vb for ${vbType}`);

    // Check if video is disabled
    this.toggleVideoState(vbType);

    console.log('this.selectedOption == image.id', this.selectedOption, image.id);
    if (this.selectedOption && this.selectedOption == image.id && !reapply) {
      enxLog('no selected option');
      return;
    }

    this.vbList.classList.add('loading');

    if (image) {
      this.selectedOption = image.id;
      this.clearSelectedItem();
      if (document.querySelector(`#img-${this.selectedOption}`)) {
        document.querySelector(`#img-${this.selectedOption}`).classList.add('vb-selected');
      }
    }

    // console.log(vbType, 'vbType === "none": ', vbType === "none" ? false : true);
    this.vb = vbType === "none" ? false : true;

    if (image && image.src !== "none" && image.src !== "blur" && newImage && image.category !== "uploaded") {
      const url = await this.toDataURL(window.location.origin + image.src);
      this.selectedImageData = url;
    } else if (image && image.src !== "none" && image.src !== "blur" && newImage && image.category === "uploaded") {
      this.selectedImageData = image.src;
    } else if (image && (image.src == 'none' || image.src == 'blur')) {
      this.selectedImageData = null;
    }

    let backgroundAttribute = this.setBackground;

    console.log(JSON.stringify(backgroundAttribute));
    // console.log('newImage: ', newImage);

    if (backgroundAttribute && !newImage) {
      // console.log('Inside backgroundAttribute -- ');
      this.selectedImageData = backgroundAttribute.imageUrl;
    }
    // enxLog(`this.selectedImageData: ${this.selectedImageData}`);
    // console.log('backgroundAttribute.imageUrl: ', backgroundAttribute.imageUrl);
    // console.log('this.selectedImageData: ', this.selectedImageData);
    // console.log('this.isBackgroundImage(): ', isBackgroundImage());

    let imageUrl = (vbType === 'vb' && this.selectedImageData && !reapply) ?
      this.selectedImageData :
      isBackgroundImage() ?
        backgroundAttribute.imageUrl :
        null;

    console.log('imageUrl: ', imageUrl);

    this.background = {
      imageUrl: imageUrl,
      type: isBackgroundImage() ? backgroundAttribute.type : vbType,
      src: isBackgroundImage() ? backgroundAttribute.imageUrl : image.src,
      id: isBackgroundImage() ? backgroundAttribute.id : image.id,
      category: isBackgroundImage() ? backgroundAttribute.category : image.category
    };

    console.log('this.background: ', this.background);
    return await this.previewEffect();
    function isBackgroundImage() {
      return backgroundAttribute && !newImage;
    }
  }

  /**
   * Set preview background none
   */
  setNoneBackground() {
    this.setImageBackground('none', {
      id: "-1",
      src: "none",
      category: "predefined",
    }, true, true);
  }

  /**
   * Check if video is muted and enable|disable the local view 
   * @param {String} vbType | 
   */
  toggleVideoState(vbType) {
    if (this.config.stream.isVideoMuted()) {
      if (vbType != 'none') {
        enxLog('enable setLocalView start');
        this.config.stream.setLocalView(true, (res) => {
          console.log('response from setLocalView when enabled: ', res);
        });
        enxLog('enable setLocalView end');
      }
      else {
        enxLog('disable setLocalView start');
        this.config.stream.setLocalView(false, (res) => {
          console.log('response from setLocalView when disabled: ', res);
        });
        enxLog('disable setLocalView end');
      }
    }
  }

  /**
   *  To see the preview of the effect before applying
   */
  async previewEffect() {
    console.log('Executing preview: ', this.selectedImageData, ' -- ', this.background);
    if (this.config?.stream?.config?.video === false || !this.config.stream) {
      toastr.error('Camera not found');
      return;
    }

    if (document.querySelector(`#${this.previewInputCanvas}`)) {
      console.log('this.previewInputCanvas: ', this.previewInputCanvas);
      document.querySelector(`#${this.previewInputCanvas}`).remove();
    }
    if (document.querySelector(`#${this.previewInputVideo}`)) {
      console.log('this.previewInputVideo: ', this.previewInputVideo);
      document.querySelector(`#${this.previewInputVideo}`).remove();
    }

    if ((this.background.type === 'vb' && this.selectedImageData) || this.background.type == 'blur' || this.background.type == 'none') {
      enxLog('calling createVirtualBackgroundEffect');
      await this.createVirtualBackgroundEffect(this.background, 'preview')
        .then(res => {
          enxLog('Loading effects');
          this.vbList.classList.remove('loading');
          this.streamPreviewBGEffect.startPreview();
          return true;
        });
      enxLog('Executed preview');
    }
  }

  applyEffectOnPreview(withPreviousImage=false) {
    if (withPreviousImage) {
      if (this.background) {
        let backgroundAttribute = this.background;
        if (backgroundAttribute.type == 'none' || backgroundAttribute.type == 'blur') {
          let vbType = backgroundAttribute.type;
          this.setImageBackground(vbType, backgroundAttribute, true, true);
        } else {
          this.setImageBackground('vb', backgroundAttribute, true, true);
        }
      } else {
        let backgroundAttribute = {
          id: "-1",
          src: "none",
          category: "predefined",
        };
        this.setImageBackground('none', backgroundAttribute, true, true);
      }
    } else {
      if (this.setBackground) {
        let backgroundAttribute = this.setBackground;
        if (backgroundAttribute.type == 'none' || backgroundAttribute.type == 'blur') {
          let vbType = backgroundAttribute.type;
          this.setImageBackground(vbType, backgroundAttribute, true, true);
        } else {
          this.setImageBackground('vb', backgroundAttribute, true, true);
        }
      } else {
        let backgroundAttribute = {
          id: "-1",
          src: "none",
          category: "predefined",
        };
        this.setImageBackground('none', backgroundAttribute, true, true);
      }
    }
    
  }

  /**
   * Apply the effect
   */
  async applyEffect() {

    enxLog('Applying Effects');
    this.vbList.classList.add('applying');

    if (this.config?.stream?.config?.video === false) {
      toastr.error('Camera not found');
      return;
    }

    if (!this.selectedImageData && this.background.type !== 'blur' && this.background.type !== 'none') {
      toastr.warning('Please select a background from list above');
      return;
    }

    let backgroundAttribute = this.background;
    // console.log('background attribute:: ', backgroundAttribute);
    if (backgroundAttribute.type == 'none') {
      this.closePreviewWorkersAndRestoreStream();
      this.vbList.classList.remove('applying');
      if (this.background) {
        this.setBackground = backgroundAttribute;
      }
    } else {
      if (document.querySelector(`#${this.mainOutputCanvas}`)) {
        console.log('this.mainOutputCanvas: ', this.mainOutputCanvas);
        document.querySelector(`#${this.mainOutputCanvas}`).remove();
      }
      if (document.querySelector(`#${this.mainOutputVideo}`)) {
        console.log('this.mainOutputVideo: ', this.mainOutputVideo);
        document.querySelector(`#${this.mainOutputVideo}`).remove();
      }
  
      this.stopVB('main');
      await this.createVirtualBackgroundEffect(this.background, 'main')
        .then(res => {
          enxLog('Loading effects');
          this.streamMainBGEffect.startPreview("main");
          this.streamMainBGEffect.applyEffects();
          this.vbList.classList.remove('applying');
          return true;
        });
    }
  }

  closePreviewWorkersAndRestoreStream() {
    this.stopVB('preview');
    this?.streamMainBGEffect?.localStream?.changeInputMediaSource({
      stream: null, audio: true, video: true
    }, (res) => {
      console.log('res -- changeInputMediaSource 2: ', res);
    });

    this.stopVB('main');
  }

  /**
   * Upload image to add to the list and use as VB
   * @param {*} imageFile | File
   */
  async uploadImage(imageFile) {
    const _this = this;
    const reader = new FileReader();

    reader.readAsDataURL(imageFile[0]);
    reader.onload = async () => {
      const url = await _this.resizeImage(reader.result);
      const uuId = uuid.v4();

      _this.images = [
        ..._this.images,
        {
          id: uuId,
          src: url,
          category: "uploaded",
        },
      ];

      console.log('uploadImage images: ', _this.images);
      _this.init();
    };
    reader.onerror = () => {
      console.error("Failed to upload virtual image!");
    };
  }

  setExternalImages(fromQS, fromDB) {
    const _this = this;
    if (fromDB.length > 0 && fromQS.length === 0) {
      this.setImages(fromDB, _this);
    }
    else if (fromDB.length > 0 && fromQS.length > 0) {
      this.setImages(fromQS, _this);
    }
    else {
      this.setImages(fromQS, _this);
    }
  }


  setImages(images, _this) {
    images.forEach(image => {
      const uuId = uuid.v4();
      _this.images = [
        ..._this.images,
        {
          id: uuId,
          src: image,
          category: "uploaded",
        },
      ];
    });
  }

  resizeImage(base64image, width = 1280, height = 800) {
    return new Promise((resolve) => {
      const img = document.createElement("img");

      img.onload = function () {
        // Create an off-screen canvas.
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        // Set its dimension to target size.
        canvas.width = width;
        canvas.height = height;

        // Draw source image into the off-screen canvas.
        // TODO: keep aspect ratio and implement object-fit: cover.
        context.drawImage(img, 0, 0, width, height);

        // Encode image to data-uri with base64 version of compressed image.
        resolve(canvas.toDataURL("image/jpeg", 0.5));
      };
      img.src = base64image;
    });
  }

  async handleSelected(file) {
    const reader = new FileReader();
    return new Promise((resolve) => {
      reader.onload = (event) => {
        if (event.type === "load") {
          resolve(reader.result);
        }
      };
      reader.readAsDataURL(file);
    });
  }

  async toDataURL(url) {
    let bUrl = url;
    const response = await fetch(bUrl);
    const blob = await response.blob();
    let result = await this.handleSelected(blob);
    return result;
  }

  async createVirtualBackgroundEffect(background, forWhat) {
    let tflite;
    let _this = this;

    if (wasmCheck?.feature?.simd) {
      tflite = await createTFLiteSIMDModule();
    } else {
      tflite = await createTFLiteModule();
    }

    const modelBufferOffset = tflite._getModelBufferMemoryOffset();
    const modelResponse = await fetch(wasmCheck.feature.simd ? _this.models.model144 : _this.models.model96);
    if (!modelResponse.ok) {
      throw new Error("Failed to download tflite model!");
    }

    const model = await modelResponse.arrayBuffer();
    tflite.HEAPU8.set(new Uint8Array(model), modelBufferOffset);
    tflite._loadModel(model.byteLength);
    // console.log('_this.config: ', _this.config);
    let options = {
      ...(wasmCheck.feature.simd ?
        _this.segmentationDimensions.model144 :
        _this.segmentationDimensions.model96),
      selectedImageData: _this.selectedImageData,
      localVideoId: _this.config.localVideoId,
      localOptions: _this.config.localOptions,
      previewDomElement: _this.previewDomElement,
      domElement: _this.domElement,
      stream: _this.config.stream,
      handleApplyEffect: _this.config.handleApplyEffect,
      previewStream: _this.config.previewStream,
    };

    if (background) {
      Object.assign(options, { background: background });
    }
    if (forWhat != "preview") {
      this.stopVB('main');
      this.streamMainBGEffect = new StreamBackgroundEffect(tflite, options, "main");
      this.streamMainBGEffect.parentObject = this;
    } else {
      this.stopVB('preview');
      if (document.querySelector(`#${this.previewInputCanvas}`)) {
        document.querySelector(`#${this.previewInputCanvas}`).remove();
      }
      if (document.querySelector(`#${this.previewInputVideo}`)) {
        document.querySelector(`#${this.previewInputVideo}`).remove();
      }
      this.streamPreviewBGEffect = new StreamBackgroundEffect(tflite, options, "preview");
    }
  }


  stopVB(forWhat = "preview") {
    if (forWhat == 'preview') {
      if (this.streamPreviewBGEffect && this.streamPreviewBGEffect._maskFrameTimerWorker) {
        this.streamPreviewBGEffect.stopEffect();
      }
      if (document.querySelector(`#${this.previewInputCanvas}`)) {
        document.querySelector(`#${this.previewInputCanvas}`).remove();
      }
      if (document.querySelector(`#${this.previewInputVideo}`)) {
        document.querySelector(`#${this.previewInputVideo}`).remove();
      }
      if (!this.setBackground) {

      }
    } else {
      if (this.streamMainBGEffect && this.streamMainBGEffect._maskFrameTimerWorker) { 
        this.streamMainBGEffect.stopEffect();
      }
      if (document.querySelector(`#${this.mainOutputCanvas}`)) {
        console.log('this.mainOutputCanvas: ', this.mainOutputCanvas);
        document.querySelector(`#${this.mainOutputCanvas}`).remove();
      }
      if (document.querySelector(`#${this.mainOutputVideo}`)) {
        console.log('this.mainOutputVideo: ', this.mainOutputVideo);
        document.querySelector(`#${this.mainOutputVideo}`).remove();
      }
    }
  }

  isObjectEmpty(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }
  setStreams(whichStream = "main", stream) {
    if (whichStream == 'main') {
      this.config.stream = stream;
    } else {
      this.config.previewStream = stream;
    }
  }
}
